/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query RouteReadQuery($routeId: ID) {
  RouteRead(routeId: $routeId) {
    id,
    displayName,
    type
  }
}
`
